export default __webpack_public_path__ + "static/media/MielDeAbejaCom.4d0fd89b.jpeg";